import React from "react"
import classes from "./footer.module.css"

const Footer = () => {
  return (
    <div className={classes.Footer}>
      <p>
        <a href="#">
          <i
            className="fa fa-angle-up"
            style={{ fontSize: "46px", color: "white" }}
          ></i>
        </a>
      </p>
      <p>© Smart Skin Salon {new Date().getFullYear()}</p>
    </div>
  )
}

export default Footer
